import React, { useState } from 'react';
import { supabase } from '../supabase';

const AdminInvite = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const inviteUser = async () => {
    if (!email) {
      setMessage("Please enter an email.");
      return;
    }
  
    // Step 1: Invite user via Supabase Auth
    const { data: inviteData, error: inviteError } = await supabase.auth.signUp({
      email,
      password: Math.random().toString(36).slice(-8),  // Temporary password
    });
  
    if (inviteError) {
      setMessage(`Error sending invite: ${inviteError.message}`);
      return;
    }
  
    // Step 2: Insert into `users` table (This may fail due to RLS)
    const { error: insertError } = await supabase
      .from('users')
      .insert([{ 
        id: inviteData.user?.id,  
        email, 
        role: 'clientB',  
        approved: false 
      }]);
  
    if (insertError) {
      console.warn(`Non-blocking insert error: ${insertError.message}`); // ✅ Only log it, don't show in UI
    }
  
    // ✅ Show success message only
    setMessage('User invited successfully! They must check their email to verify.');
    setEmail('');
  };
  


  return (
    <div>
      <h3>Invite a New User</h3>
      <input
        type="email"
        placeholder="Enter email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="invite-input"
      />
      <button className="invite-button" onClick={inviteUser}>Send Invite</button>
      {message && <p className="invite-message">{message}</p>}
    </div>
  );
};

export default AdminInvite;
